import styled from "styled-components";

export const CustomerFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    flex: 1 0 0;
    align-self: stretch;
`;